import React from 'react';
import Logo from '../black logo.png';

function Spinner() {
  return (
    <div className='text-center'>
      {/* 1st reactangle */}
      <svg className='md:w-20 w-14 inline-block' version="1.1" id="L6" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enableBackground="new 0 0 100 100" xmlSpace="preserve">
        <rect fill="#33323d" stroke="#33323d" strokeWidth="14" x="25" y="25" width="50" height="50"  rx="8">
          <animateTransform
            attributeName="transform"
            dur="0.19s"  // updated duration to 0.25s
            from="0 50 50"
            to="180 50 50"
            type="rotate"
            id="strokeBox"
            attributeType="XML"
            begin="rectBox.end"
          />
        </rect>
        <rect x="27" y="27" fill="#fff" width="46" height="50"  rx="8">
          <animate
            attributeName="height"
            dur="0.46s"  // updated duration to 0.65s
            attributeType="XML"
            from="50"
            to="0"
            id="rectBox"
            fill="freeze"
            begin="0.1s;strokeBox.end"
          />
        </rect>
      </svg>
      {/* 2nd reactangle */}
      <svg className='md:w-20 w-14 inline-block border border-zinc-600 rounded-full' version="1.2" id="L6" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enableBackground="new 0 0 100 100" xmlSpace="preserve">
        <rect fill="#33323d" stroke="#33323d" strokeWidth="14" x="25" y="25" width="50" height="50"  rx="8">
          <animateTransform
            attributeName="transform"
            dur="0.19s"
            from="0 50 50"
            to="-180 50 50"
            type="rotate"
            id="strokeBox2"
            attributeType="XML"
            begin="rectBox2.end"
          />
        </rect>
        <rect x="27" y="27" fill="#fff" width="46" height="50"  rx="8">
          <animate
            attributeName="height"
            dur="0.46s"
            attributeType="XML"
            from="50"
            to="0"
            id="rectBox2"
            fill="freeze"
            begin="0.2s;strokeBox2.end"
          />
        </rect>
      </svg>
      {/* 3rd reactangle */}
      <svg className='md:w-20 w-14 inline-block' version="1.1" id="L6" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enableBackground="new 0 0 100 100" xmlSpace="preserve">
        <rect fill="#33323d" stroke="#33323d" strokeWidth="14" x="25" y="25" width="50" height="50"  rx="8">
          <animateTransform
            attributeName="transform"
            dur="0.19s"  // updated duration to 0.25s
            from="0 50 50"
            to="180 50 50"
            type="rotate"
            id="strokeBox"
            attributeType="XML"
            begin="rectBox.end"
          />
        </rect>
        <rect x="27" y="27" fill="#fff" width="46" height="50"  rx="8">
          <animate
            attributeName="height"
            dur="0.46s"  // updated duration to 0.65s
            attributeType="XML"
            from="50"
            to="0"
            id="rectBox"
            fill="freeze"
            begin="0.2s;strokeBox.end"
          />
        </rect>
      </svg>
      <div className='flex mt-3'>
        <img src={Logo} alt="Portfolio logo" className="w-9 md:w-14 h-auto" />
        <h1 className='md:text-3xl text-lg main-font tracking-widest md:mt-5 mt-4 ml-3 text-center'>
          <strong>
            <span className="inline-block animate-slide-in-left">
              Portfolio
            </span>
          </strong> 
        </h1>
      </div>
    </div>
  );
}

export default Spinner;
